(function(){
  var cfg = window.DSD_RO || {};
  var fab = document.getElementById('roFab');
  var ov = document.getElementById('roOv');
  var panel = document.getElementById('roPanel');
  var list = document.getElementById('roList');
  var close = document.getElementById('roClose');
  if (!fab || !panel || !list) return;
  [ov, panel, fab].forEach(function (n) { if (n && n.parentElement !== document.body) document.body.appendChild(n); });
  var en = !!cfg.en;
  var loaded = false;

  function ago(iso) {
    var d = new Date(iso);
    var m = Math.max(1, Math.round((Date.now() - d.getTime()) / 60000));
    if (m < 60) return en ? (m + ' min ago') : ('il y a ' + m + ' min');
    var h = Math.round(m / 60);
    if (h < 24) return en ? (h + ' h ago') : ('il y a ' + h + ' h');
    var j = Math.round(h / 24);
    if (j < 7) return en ? (j + ' d ago') : ('il y a ' + j + ' j');
    var s = Math.round(j / 7);
    return en ? (s + ' w ago') : ('il y a ' + s + ' sem');
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }

  function render(rows) {
    if (!rows || !rows.length) { list.innerHTML = '<div class=ro-empty>' + (en ? 'No recent orders.' : 'Aucune commande recente.') + '</div>'; return; }
    var max = cfg.max || 40;
    var out = '';
    rows.slice(0, max).forEach(function (o) {
      var p = Array.isArray(o.products) ? o.products.join(', ') : (o.products || '');
      var city = o.city ? (' <span class=ro-city>· ' + esc(o.city) + '</span>') : '';
      out += '<div class=ro-item><div><div class=ro-name>' + esc(o.name) + city + '</div><div class=ro-prod>' + esc(p) + '</div></div><div class=ro-time>' + esc(ago(o.date)) + '</div></div>';
    });
    list.innerHTML = out;
  }

  function load() {
    if (loaded) return;
    loaded = true;
    // 1) Données rendues depuis le métachamp (rafraîchies automatiquement) — aucun fetch.
    if (Array.isArray(cfg.data) && cfg.data.length) { render(cfg.data); return; }
    // 2) Repli : ancien fichier JSON du thème.
    if (!cfg.url) { render([]); return; }
    fetch(cfg.url).then(function (r) { return r.json(); }).then(render).catch(function () {
      list.innerHTML = '<div class=ro-empty>' + (en ? 'Unavailable.' : 'Indisponible.') + '</div>';
    });
  }

  function open() { load(); panel.classList.add('open'); if (ov) ov.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
  function shut() { panel.classList.remove('open'); if (ov) ov.classList.remove('open'); document.documentElement.style.overflow = ''; }

  fab.addEventListener('click', open);
  if (close) close.addEventListener('click', shut);
  if (ov) ov.addEventListener('click', shut);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
})();
